import React from 'react';
import './Contact.css';
import { useRef, useEffect } from 'react';
import emailjs from 'emailjs-com';
import confetti from 'canvas-confetti';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdEmail } from "react-icons/md";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaRegCalendarCheck } from "react-icons/fa";
import { motion } from 'framer-motion';
import { CAL_LINK, CAL_NAMESPACE, CAL_CONFIG, initCalPopup } from '../../config/cal';

const Contact = () => {
  const form = useRef();

  // Initialise the Cal.com booking popup, themed to match the site.
  useEffect(() => {
    initCalPopup();
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_uy9pujn', 'template_nlwfwfx', form.current, 'kmgIE-sCPzQWu58-I')
      .then(() => {
        toast.success('Your message has been sent successfully!', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'colored',
        });

        confetti({
          particleCount: 180,
          spread: 100,
          origin: { y: 0.6 },
          colors: ['#4db5ff', '#ffffff', '#2c8fdf', '#a8d8ff'],
          ticks: 200,
        });

        e.target.reset();
      },
      (error) => {
        console.error('EmailJS error:', error);
        toast.error('Failed to send the message. Try again later.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'colored',
        });
      });
  };

  return (
    <section id='contact'>
      <h5>Get In Touch With me</h5>
      <h2>Contact me</h2>
      <motion.div 
        className="container contact__container"
        initial={{ opacity: 0, y: 50, rotateX: 8 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        style={{ perspective: 1000 }}
      >
        <div className="contact__options">
          <article className="contact__option contact__option--book">
            <div className='contact__option-icon'><FaRegCalendarCheck /></div>
            <h4>Book a Call</h4>
            <h5>Free 30-min intro call</h5>
            <button
              type="button"
              className="contact__book-link"
              data-cal-namespace={CAL_NAMESPACE}
              data-cal-link={CAL_LINK}
              data-cal-config={CAL_CONFIG}
            >
              Schedule a Call
            </button>
          </article>
          <article className="contact__option">
            <div className='contact__option-icon'><MdEmail /></div>
            <h4>Email</h4>
            <h5>syedmaazsaeed@gmail.com</h5>
            <a href="mailto:syedmaazsaeed@gmail.com" target="_blank" rel="noreferrer">Reach Me by Email</a>
          </article>
          <article className="contact__option">
            <div className='contact__option-icon'><FaInstagram /></div>
            <h4>Instagram</h4>
            <h5>syedmaazsaeed</h5>
            <a href="https://www.instagram.com/syedmaazsaeed/" target="_blank" rel="noreferrer">Engage on Instagram</a>
          </article>
          <article className="contact__option">
            <div className='contact__option-icon'><FaWhatsapp /></div>
            <h4>Whatsapp</h4>
            <h5>+92-310-690200-2</h5>
            <a href="https://api.whatsapp.com/send?phone=923106902002" target="_blank" rel="noreferrer">Chat with Me</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your Full Name' required />
          <input type="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows='7' placeholder='Your Message' required />
          <button type='submit' className='btn btn-primary btn-swing'>Send Message</button>
        </form>
      </motion.div>
      <ToastContainer />
    </section>
  );
};

export default Contact;
